module.exports = __webpack_public_path__ + "media/brands/lingben-e38e1a6c.png";